import styled from 'styled-components'

const CreditCardLabelUi = styled.label`
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:after {
    content: '*';
    color: red;
  }
`

export default CreditCardLabelUi
